import React from 'react';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import DialogTitle from "@material-ui/core/DialogTitle";
import {importacionesResources} from "../endpoints";
import Grid from "@material-ui/core/Grid";

class DialogCargarArchivos extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
            rowData : this.props.rowData,
            file : "",
            progress: false,
            disabled: false,
            severity: null,
            message: null
        }

    }

    handleOnFileChange = (e) => {
        let file = e.target.files[0];
        this.setState({
            [e.target.id] : file
        })
    }


    submitForm = () => {
        this.setState({progress:true,disabled:true})
        const formData = new FormData();
        formData.append("file",this.state.file);
        importacionesResources.cargarArchivos(formData,this.state.rowData.folio).then( async response => {
            if(response){
                return await response.json()
            }
        }).then( result => {
            if(result.message){
                this.setState({
                    progress:false,
                    disabled:false}, this.props.refrescar(result.message,result.severity))
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.error(error);
            this.setState({
                progress:false,
                message: "Ha ocurrido un error inesperado",
                severity: "error",
                disabled:false})
        });
    }

    render() {
        return(
            <Dialog
                open={true}
                maxWidth="md"
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Cargar Archivos</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                inputProps={{
                                        accept: ".pdf,.png,.jpg,.jpeg,.txt,.csv,.xls,.xlsx"
                                    }}                                
                                style={{width:'auto'}}
                                type={"file"}
                                id="file"
                                label="Seleccione archivo"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                variant="outlined"
                                onChange={this.handleOnFileChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            {this.state.progress ? <CircularProgress style={{display: 'inline-grid', justifySelf: 'center'}}/>: null}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button disabled={!this.state.file || this.state.disabled} variant="contained" color={'primary'} onClick={this.submitForm}>
                        Subir archivo
                    </Button>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

}

export default DialogCargarArchivos;